// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"336":"35ab44f1","395":"5518e3d3","436":"59de0603","698":"2bf80dbd","748":"7f483838","896":"4d710e3a","954":"312ca2c8"}[chunkId] + ".chunk.js";
};